var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shift Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.08,1.94H11.92V3.27A.72.72,0,0,1,11.2,4h-1a.72.72,0,0,1-.72-.72V1.94h-4V3.27A.72.72,0,0,1,4.81,4h-1a.72.72,0,0,1-.72-.72V1.94H1.92a.86.86,0,0,0-.86.86V14a.86.86,0,0,0,.86.86H13.08a.86.86,0,0,0,.86-.86V2.8A.86.86,0,0,0,13.08,1.94Zm0,11.22a.66.66,0,0,1-.66.66H2.72a.66.66,0,0,1-.66-.66V5.68A.66.66,0,0,1,2.72,5h9.66a.66.66,0,0,1,.66.66Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.56,
    y: 0.19,
    width: 1.5,
    height: 3.3,
    rx: 0.24,
    ry: 0.24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.96,
    y: 0.19,
    width: 1.5,
    height: 3.3,
    rx: 0.24,
    ry: 0.24
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23,
    y: 5.4,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 5.4,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.47,
    y: 5.4,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23,
    y: 8.2,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 8.2,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.47,
    y: 8.2,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23,
    y: 11.01,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.35,
    y: 11.01,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.47,
    y: 11.01,
    width: 2.45,
    height: 2.46,
    rx: 0.27,
    ry: 0.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShift);
export default __webpack_public_path__ + "static/media/shift.73064aa6c22a9e7681ccc92904e64c26.svg";
export { ForwardRef as ReactComponent };